import App from "./App.vue";
//  引用指令
import "./directives/index";
//  引用过滤器
import "./filters/index";
//  引入公共组件
import "./framework";
//  mixin
import mixin from "./mixin/index";
import router from "./router";
//  引入全局样式
import "./scss/_index.scss";
//  引入 rtl 布局样式
import "./scss/_rtl.scss";
import "./setup/index";
import store from "./store";
//  Plugin
import 'g2embedded'
import "./vendor/range.min.css";
// import "./vendor/a2aButtons";
import "./vendor/tabs.min.css";
//  引入进度条样式
import "nprogress/nprogress.css";
import Vue from "vue";

new Vue({
  el: "#app",
  router,
  store,
  render: (h) => h(App),
});

